import { get } from './httpClient';

interface ValidateDuplicateResponse {
    data: null;
    paging: null;
    statusCode: number;
    isError: boolean;
    title: string;
    developerMessage: string;
    message: string;
    messageArgs: null;
    userType: null;
}

type ExistsParams = {
    apiUrl: string;                 // API endpoint
    value: string | number;         // code / email / phone / name etc.
    fieldName?: string;             // default: value
    id?: number;                    // for edit case
    extraParams?: Record<string, string | number | undefined>;
};


export const isExists = async ({
    apiUrl,
    value,
    fieldName = 'value',
    id,
    extraParams = {},
}: ExistsParams): Promise<{ exists: boolean }> => {

    const queryParams = new URLSearchParams();

    queryParams.append(fieldName, String(value));

    if (id) {
        queryParams.append('id', String(id));
    }

    Object.entries(extraParams).forEach(([key, val]) => {
        if (val !== undefined && val !== null) {
            queryParams.append(key, String(val));
        }
    });

    const response = await get<ValidateDuplicateResponse>(
        `${apiUrl}?${queryParams.toString()}`
    );

    if (response.isError) {
        // API indicates duplicate exists
        throw new Error(response.title || response.message);
    }

    return { exists: false };
};


export const

    checkNationalIDNo = async (nationalIDNo: string, companyId?: number, id?: number): Promise<{ exists: boolean }> => {
    const url = `/PolicyHolder/CheckNationalIDNo?nationalIDNo=${encodeURIComponent(nationalIDNo)}`
        + (companyId ? `&companyId=${companyId}` : "")
        + (id ? `&id=${id}` : "");
    const response = await get<ValidateDuplicateResponse>(url);

    if (response.isError) {
        // If isError is true, it means the National ID No already exists.
        // The validator will catch this and use the title as the error message.
        throw new Error(response.title); 
    }

    // If isError is false, it means the National ID No does not exist.
    return { exists: false };
};

export const CheckUserName = async (userName: string, id?: number): Promise<{ exists: boolean }> => {
    const url = `/User/CheckUserName?userName=${encodeURIComponent(userName)}${id ? `&id=${id}` : ""}`;
    const response = await get<ValidateDuplicateResponse>(url);

    if (response.isError) {
        // If isError is true, it means the userName already exists.
        // The validator will catch this and use the title as the error message.
        throw new Error(response.title);
    }

    // If isError is false, it means the userName does not exist.
    return { exists: false };
};

export const CheckEmail = async (email: string, id?: number): Promise<{ exists: boolean }> => {
    const url = `/User/CheckEmail?email=${encodeURIComponent(email)}${id ? `&id=${id}` : ""}`;
    const response = await get<ValidateDuplicateResponse>(url);

    if (response.isError) {
        throw new Error(response.title);
    }

    return { exists: false };
};

export const CheckCategoryItemCode= async (code: string, id?: number): Promise<{ exists: boolean }> => {
    const url = `/ServiceCategoryItem/CheckCategoryItemCode?code=${encodeURIComponent(code)}${id ? `&id=${id}` : ""}`;
    const response = await get<ValidateDuplicateResponse>(url);

    if (response.isError) {
        // If isError is true, it means the code already exists.
        // The validator will catch this and use the title as the error message.
        throw new Error(response.title);
    }

    // If isError is false, it means the code does not exist.
    return { exists: false };
};

export const CheckICDCode = async (code: string, id?: number): Promise<{ exists: boolean }> => {
    const url = `/ICD/CheckICDCode?code=${encodeURIComponent(code)}${id ? `&id=${id}` : ""}`;
    const response = await get<ValidateDuplicateResponse>(url);

    if (response.isError) {
        // If isError is true, it means the code already exists.
        // The validator will catch this and use the title as the error message.
        throw new Error(response.title);
    }

    // If isError is false, it means the code does not exist.
    return { exists: false };
};